import { useSession } from "../auth/session"
import "./AccessDenied.css"

// The PWA is scoped to Admin / Manager accounts; everyone else uses the native app.
export default function AccessDenied() {
  const { user, signOut } = useSession()

  return (
    <div className="access-denied">
      <img className="access-denied__mark" src="/img/vantero-wordmark.svg" alt="Vantero Hospitality" />
      <h1 className="access-denied__title t-y24">Admin access required</h1>
      <p className="access-denied__body t-p14">
        {user?.email ? `${user.email} is not an admin account. ` : ""}
        The Menu app is available to restaurant admins. Use the Vantero app for other accounts.
      </p>
      <button type="button" className="access-denied__action t-p16" onClick={signOut}>
        Log Out
      </button>
    </div>
  )
}
